import React, { useState, useEffect } from "react";
import { serverFetch } from "@extensions";
import { useCompany, useUser } from "@redux";
import dayjs from "dayjs";
import "./catalog-sale-time.css";

const CatalogSaleTime = ({ userId, roomId, productId, selectedDate, onSelect }) => {
  const company = useCompany();
  const user = useUser();
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedTime, setSelectedTime] = useState(null);

  useEffect(() => {
    if ((userId || roomId) && productId && selectedDate && company) {
      fetchSessions();
    } else {
      setSessions([]);
      setSelectedTime(null);
      if (onSelect) {
        onSelect(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, roomId, productId, selectedDate, company]);

  const fetchSessions = async () => {
    if (!company || (!userId && !roomId) || !productId || !selectedDate) return;

    setLoading(true);
    setSelectedTime(null);
    if (onSelect) {
      onSelect(null);
    }
    try {
      const queryParams = {
        productId: productId,
        date: selectedDate.format("YYYY-MM-DD"),
      };
      const endpoint = roomId ? "Online/Rooms" : "Online/Seanses";
      if (roomId) {
        queryParams.roomId = roomId;
      } else {
        queryParams.userId = userId;
      }
      const data = await serverFetch(endpoint, { method: "GET", queryParams: queryParams }, user);
      setSessions(data || []);
    } catch (error) {
      console.error("Ошибка получения сеансов:", error);
      setSessions([]);
    } finally {
      setLoading(false);
    }
  };

  const isTimeAvailable = (session) => {
    if (!session.available) {
      return false;
    }

    // Если дата - сегодня, проверяем, не прошло ли время
    if (selectedDate && dayjs(selectedDate).isSame(dayjs(), "day")) {
      const now = dayjs();
      const currentTimeStr = now.format("HH:mm:ss");
      
      // Сравниваем строки времени напрямую (формат "HH:mm:ss")
      if (session.time < currentTimeStr) {
        return false;
      }
    }

    return true;
  };

  const handleTimeSelect = (session) => {
    if (isTimeAvailable(session)) {
      setSelectedTime(session.time);
      if (onSelect) {
        onSelect(session.time);
      }
    }
  };

  if (loading) {
    return (
      <div className="catalog-sale-time-loading">
        <div>Загрузка...</div>
      </div>
    );
  }

  if (!sessions || sessions.length === 0) {
    return null;
  }

  return (
    <div className="catalog-sale-time">
      <div className="catalog-sale-time-title">Выберите время</div>
      <div className="catalog-sale-time-slots">
        {sessions.map((session, index) => {
          const timeStr = session.time;
          const timeDisplay = timeStr.length >= 5 ? timeStr.substring(0, 5) : timeStr;
          const isSelected = selectedTime === session.time;
          const isAvailable = isTimeAvailable(session);

          return (
            <button
              key={index}
              className={`catalog-sale-time-slot ${isSelected ? "selected" : ""} ${!isAvailable ? "unavailable" : ""}`}
              onClick={() => handleTimeSelect(session)}
              disabled={!isAvailable}
            >
              {timeDisplay}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CatalogSaleTime;

